export { default } from './SectionBenefits';